import { FC } from 'react';
import classNames from 'classnames';

import { ImagePackSetVariation } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import { H3 } from '@rikstv/shared-components';

import { Breakpoints } from '../../grid/breakpoints';
import { getLinkTo } from '../swimlane.utils';

import { ItemWrapper } from './ItemWrapper';
import { StandardItem, StandardItemProps } from './StandardItem';

import styles from './MenuTextItem.module.css';

export const MenuSwimlaneItem: FC<StandardItemProps> = props => {
  if (
    props.swimlaneStyle === 'MenuThumbnail' ||
    props.swimlaneStyle === 'MenuCircle' ||
    props.swimlaneStyle === 'MenuLogo'
  ) {
    return <StandardItem {...props} centeredTitle />;
  }

  if (props.swimlaneStyle === 'MenuText') {
    return (
      <div className={classNames(styles.wrapper, 'with-keyboard-focus-within')}>
        <ItemWrapper className={styles.menuTextItem} linkTo={getLinkTo(props.asset)} onClick={props.onClick}>
          <H3 className={styles.menuItemTitle} lookLike={'title-4'}>
            {props.asset.title}
          </H3>
        </ItemWrapper>
      </div>
    );
  }
};

//used for menuCircle and menuLogo
export const menuIconsImageConfig: ImagePackSetVariation[] = [
  { width: 150, breakpoint: Breakpoints.MD },
  { width: 200, breakpoint: Breakpoints.DEFAULT },
];

export const menuThumbnailItemImageConfig: ImagePackSetVariation[] = [{ width: 300, breakpoint: Breakpoints.DEFAULT }];

export const swimlaneConfig = {
  MenuLogo: {
    placeholderHeight: {
      [Breakpoints.XS]: 225,
      [Breakpoints.SM]: 225,
      [Breakpoints.MD]: 225,
      [Breakpoints.ML]: 225,
      [Breakpoints.LG]: 230,
      [Breakpoints.XL]: 250,
      [Breakpoints.XXL]: 275,
      [Breakpoints.DEFAULT]: 225,
    },
  },
  MenuCircle: {
    placeholderHeight: {
      [Breakpoints.XS]: 245,
      [Breakpoints.SM]: 390,
      [Breakpoints.MD]: 280,
      [Breakpoints.ML]: 255,
      [Breakpoints.LG]: 255,
      [Breakpoints.XL]: 280,
      [Breakpoints.XXL]: 290,
      [Breakpoints.DEFAULT]: 310,
    },
  },
  MenuThumbnail: {
    placeholderHeight: {
      [Breakpoints.XS]: 265,
      [Breakpoints.SM]: 410,
      [Breakpoints.MD]: 300,
      [Breakpoints.ML]: 275,
      [Breakpoints.LG]: 275,
      [Breakpoints.XL]: 300,
      [Breakpoints.XXL]: 310,
      [Breakpoints.DEFAULT]: 310,
    },
  },
  MenuText: {
    placeholderHeight: {
      [Breakpoints.XS]: 200,
      [Breakpoints.SM]: 200,
      [Breakpoints.MD]: 200,
      [Breakpoints.ML]: 200,
      [Breakpoints.LG]: 200,
      [Breakpoints.XL]: 260,
      [Breakpoints.XXL]: 260,
      [Breakpoints.DEFAULT]: 200,
    },
  },
};
